<template>
  <div :class="$style.wrapper">
    <component
      :is="DynamicTable" 
      :exportButton="true"
      :headers="headers"
      :rows="originalRows"
      :loading-data="loadingData"
      :enable-pagination="true"
      :items-per-page="12"
    />
  </div>
</template>

<script setup>
  import { ref, onMounted, computed, resolveDynamicComponent } from 'vue';
  import { useStore } from 'vuex';
  import BaseTable from '@components/common/BaseTable.vue';
  import MobileTable from '@components/common/MobileTable.vue';
  import { formatToUSD } from '@/helpers/currencyFormatter';
  import { formatDate } from '@/helpers/dateFormatter';
  import {
    CalendarDateRangeIcon,
    CurrencyDollarIcon,
    InformationCircleIcon,
    ArrowsRightLeftIcon
  } from '@heroicons/vue/24/outline';
import transactionsService from '@/services/transactionsService';

  const store = useStore();
  const originalRows = ref([]);
  const loadingData = ref(true);
  
  const isMobile = computed(() => store.getters['device/isMobile']);

  
  const DynamicTable = computed(() =>
    resolveDynamicComponent(isMobile.value ? MobileTable : BaseTable)
  );

  const headers = [
    { title: 'Date', icon: CalendarDateRangeIcon, key: 'date' },
    { title: 'Amount', icon: CurrencyDollarIcon, key: 'amount' },
    { title: 'Status', icon: InformationCircleIcon, key: 'status' },
    { title: 'Type', icon: ArrowsRightLeftIcon, key: 'type' },
  ];


  const formatData = async (data) => {
    const cleanedRows = data.filter(item => item.exchange !== 'n');

    const formattedData = cleanedRows.map(item => ({
      date: formatDate(item.date),
      amount: formatToUSD(item.amount),
      status: item.status,
      type: item.type_amount
    }));

    return formattedData;
  };

  const fetchData = async () => {
    try {
      loadingData.value = true
      const tableData = await transactionsService.getTableData();
      originalRows.value = await formatData(tableData);
    } catch (error) {
      originalRows.value = [];
    } finally {
      loadingData.value = false;
    }
  };

  onMounted(async () => {
    await fetchData();
  });
</script>

<style module lang="scss">
  .wrapper {
    gap: 25px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    flex-direction: column;
  }
</style>